import React from 'react';
import './Home.css';
import logo from '../assets/Habibtea.jpeg';

const Home = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            {/* Left Text Content */}
            <div className="hero-text fade-in" style={{ animationDelay: '0.1s', flex: 1 }}>
              <h1>
                Premium Beverages,
                <span style={{ background: 'linear-gradient(135deg, #d4a574 0%, #c89968 100%)', backgroundClip: 'text', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}> Endless Vibes</span>
              </h1>
              <p>
                Mocktails, Dirty Sodas, and Boba crafted with love.
                Perfect for your next unforgettable event.
              </p>

              <a href="/book-now" className="cta-button">
                Book Your Event
              </a>
            </div>

            {/* Right Image */}
            <div className="hero-image fade-in" style={{ animationDelay: '0.3s', flex: 1 }}>
              <img src={logo} alt="Habibtea Premium Beverages" />
            </div>
          </div>
        </div>
      </section>

      {/* About Preview Section */}
      <section className="about-section">
        <div className="container">
          <div className="fade-in" style={{ animationDelay: '0.2s' }}>
            <h2>What is Habibtea?</h2>
            <p>
              Habibtea is a premium mobile beverage cart bringing extraordinary drinks to your celebrations.
              From stunning mocktails to creative dirty sodas and classic boba, we craft every drink with passion and precision.
            </p>

            {/* Three Drink Categories */}
            <div className="drink-categories">
              <div className="category-card"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.05)';
              }}>
                <div className="category-card-icon">🍹</div>
                <h3>Mocktails</h3>
                <p>Refreshing non-alcoholic cocktails with premium ingredients</p>
              </div>

              <div className="category-card"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.05)';
              }}>
                <div className="category-card-icon">🥤</div>
                <h3>Dirty Sodas</h3>
                <p>Creative soda combinations with gourmet syrups and toppings</p>
              </div>

              <div className="category-card"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.05)';
              }}>
                <div className="category-card-icon">🧋</div>
                <h3>Boba Tea</h3>
                <p>Classic and specialty bubble teas with premium pearls</p>
              </div>
            </div>

            <a href="/menu" className="menu-button">
              Explore Full Menu
            </a>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container fade-in" style={{ animationDelay: '0.3s' }}>
          <h2>
            Ready to Elevate Your Event?
          </h2>
          <p>
            Choose from our three signature packages and let us bring premium beverages to your celebration.
          </p>
          <a href="/book-now" className="cta-button-white"
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.3)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
          }}>
            Book Your Date Now
          </a>
        </div>
      </section>
    </div>
  );
};

export default Home;
